import contractInfoMain from './contractInfoMain';
import contractInfoTest from './contractInfoTest';

const chainList = {
  baobab: {
    name: 'baobab',
    id: 1001,
    rpcUrl: 'https://api.baobab.klaytn.net:8651',
    blockExplorerUrl: 'https://baobab.scope.klaytn.com/',
    isMainNet: false,
    contract: contractInfoTest,
  },
  cypress: {
    name: 'klaytn',
    id: 8217,
    rpcUrl: 'https://public-node-api.klaytnapi.com/v1/cypress',
    blockExplorerUrl: 'https://scope.klaytn.com',
    isMainNet: true,
    contract: contractInfoMain,
  },
};

const CURRENT_CHAIN = chainList[process.env.REACT_APP_CURRENT_CHAIN];

export default CURRENT_CHAIN;
